import PropTypes from 'prop-types';

import VoteBox from 'components/productdetail/ask/VoteBox';
import { answerPropType } from 'components/productdetail/ask/commonAskPropTypes';
import { parseTextToReact } from 'helpers/HtmlHelpers';
import css from 'styles/components/productdetail/ask/answer.scss';

const Answer = ({ answer, onReportAskAnswer, onAddAskDownvote, onAddAskUpvote }) => {
  const { author, best, date, key, text } = answer;
  const bestAnswerHeading = <div className={css.bestAnswerHeading}>Best Answer</div>;
  return (
    <div key={key} className={css.answer}>
      {best && bestAnswerHeading}
      <p>{parseTextToReact(text)}</p>
      <div className={css.meta}>{parseTextToReact(author)} on {date}</div>
      <VoteBox
        item={answer}
        isQuestion={false}
        onAddAskDownvote={onAddAskDownvote}
        onAddAskUpvote={onAddAskUpvote}
        onReportAskItem={onReportAskAnswer} />
    </div>
  );
};

Answer.propTypes = {
  answer: answerPropType,
  onReportAskAnswer: PropTypes.func.isRequired,
  onAddAskUpvote: PropTypes.func.isRequired,
  onAddAskDownvote: PropTypes.func.isRequired
};

export default Answer;
